<template>
    <span class="flex ai:center gap:8 cursor:pointer color:#5E6472 color:primary:hover" @click="toggle">
        <i class="fa-solid fa-bookmark color:#538BD4" :class="`f:${size}`" v-if="value"></i>
        <img alt="" class="w:24 h:24" :src="`${prefix}image/icon_rollback.svg`" v-else-if="rollback" />
        <i class="fa-regular fa-bookmark color:primary:hover" :class="`f:${size}`" v-else></i>
        <slot></slot>
    </span>
</template>

<script setup>
    const props = defineProps({
        topic_id: { required: true, type: Number },
        recoverable: { default: false, type: Boolean },
        size: { default: 16, type: Number },
        value: { required: true, type: Boolean }
    });

    const prefix = inject("prefix");

    const rollback = ref(props.recoverable && props.value);
    const value = ref(props.value);

    const toggle = () => {
        if (value.value) {
            api("api/topic/favorite/remove", {
                topic_id: props.topic_id
            }).done((res) => {
                if (res.success) {
                    value.value = false;
                }
            });
        } else {
            api(`api/topic/favorite/${props.recoverable ? "toggle" : "add"}`, {
                topic_id: props.topic_id
            }).done((res) => {
                if (res.success) {
                    if (props.recoverable) {
                        rollback.value = true;
                    }

                    value.value = true;
                }
            });
        }
    };
</script>
